<div class="header-bar-wrapper">
  <div class="header-bar" [class.ghost]="job == null">
    <div class="flex flex-wrap grid-gap-10 w-100">
      <div class="flex-grow-1 flex grid-gap-10 align-items-center">
        <div class="flex-shrink-1 white-space-nowrap cursor-pointer" (click)="goBack()">
          <i class="fa fa-angle-left"></i> Back
        </div>

        <div class="flex-shrink-1 incident-icons" *ngIf="job?.priorityDeployment">
          <i
            pTooltip="Priority Deployment Job"
            class="fa fa-exclamation-circle"
            style="color: #c00"
          ></i>
        </div>

        <div class="flex-shrink-1 ghost-inline job-number white-space-nowrap">
          {{ job?.jobNumber }}
        </div>
        <route-tag *ngIf="job?.routeRecommendationId"></route-tag>
        <div
          class="flex-shrink-1 ghost-inline status-chip white-space-nowrap"
          [class]="'status-chip-' + commonService.getStatusCode(job)"
        >
          {{ commonService.getStatus(job) }}
        </div>
      </div>
      <div class="flex-shrink-1">
        <div class="flex align-items-center grid-gap-5 flex-wrap">
          <ng-container *ngIf="!commonService.isJobCompleted(job) || canDeploy()">
            <div class="pt-1" *ngIf="job != null">
              <p-inputSwitch
                [(ngModel)]="job.priorityDeployment"
                (onChange)="changePriority()"
              ></p-inputSwitch>
            </div>
            <div class="switch-label">Priority</div>
          </ng-container>
          <div>
            <p-splitButton
              [styleClass]="'ui-button-secondary'"
              label="Customer Information"
              appendTo="body"
              (onClick)="linkToCustomerInfo(null)"
              [model]="customerLinkData"
            ></p-splitButton>
          </div>
          <button
            class="pull-right mt-1"
            type="button"
            (click)="onLogCall()"
            label="Log Call"
            pButton
            *ngIf="telephonyService.AnonCallLoggable$ | async"
          ></button>

          <button
            pButton
            label="Routes Inbox"
            class="ui-button ui-button-secondary"
            (click)="loadRoutesInbox()"
          ></button>

          <app-queue-auto-direct-button
            *ngIf="canQueueAutoDirect()"
            [jobIds]="[jobId]"
          ></app-queue-auto-direct-button>

          <div *ngIf="canDeploy()">
            <button pButton label="Allocate Supplier" (click)="deployJobToSupplier()"></button>
          </div>

          <div *ngIf="canDeploy()">
            <button pButton label="Deploy" (click)="jobDeployment()"></button>
          </div>

          <button
            *ngIf="canShowPriceDetails"
            class="pull-right mt-1"
            type="button"
            (click)="showPriceDetails()"
            label="Price Details"
            pButton
          ></button>
        </div>
      </div>
    </div>
  </div>
  <app-tab-scroller [tabs]="tabs" (tabSelected)="onTabSelected($event)"></app-tab-scroller>
</div>

<div [hidden]="activeViewId !== 'scroll'">
  <div class="content-container job-screen-container pt-2 scroll-id mt-3" id="jobDetails">
    <h2 class="sub-header-bar">Job Information</h2>
    <div class="flex flex-wrap grid-gap-15">
      <div style="flex-basis: 200px; flex-grow: 1; height: 100%">
        <div class="flex grid-gap-15 flex-column">
          <div>
            <app-vme-job-screen-dates-prices [jobId]="jobId"></app-vme-job-screen-dates-prices>
          </div>
          <div>
            <app-vme-job-screen-supplier-info [jobId]="jobId"></app-vme-job-screen-supplier-info>
          </div>

          <div *ngIf="job?.supplierId != 0 && job?.supplierId != null">
            <job-screen-carry-over
              [jobId]="jobId"
              [organisationId]="organisationId"
              [organisationTypeId]="organisationTypeId"
              [autoSave]="true"
            ></job-screen-carry-over>
          </div>
        </div>
      </div>

      <div style="flex-grow: 1; flex-basis: 200px">
        <div style="display: flex; flex-direction: column; height: 100%">
          <div style="flex-grow: 1">
            <app-job-screen-history
              [jobId]="jobId"
              [panelHeight]="'750px'"
              [organisationId]="organisationId"
              [organisationTypeId]="organisationTypeId"
            ></app-job-screen-history>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-3">
      <p-panel styleClass="no-padding-panel panel-shadow" class="overflow-hidden-panel">
        <p-header>
          <div class="panel-header">Incidents</div>
        </p-header>
        <vme-job-screen-incidents
          [jobId]="jobId"
          [selectedTask]="selectedTask"
          (onShowHistory)="showHistory()"
        ></vme-job-screen-incidents>
      </p-panel>
    </div>

    <div class="mt-3">
      <p-panel styleClass="no-padding-panel ov panel-shadow">
        <p-header>
          <div class="panel-header">Job Delays / Failures</div>
        </p-header>
        <job-screen-delay-failures-table
          [organisationId]="organisationId"
          [organisationTypeId]="organisationTypeId"
          [jobId]="jobId"
        ></job-screen-delay-failures-table>
      </p-panel>
    </div>

    <div class="mt-3">
      <vme-additional-costs
        [organisationTypeId]="organisationTypeId"
        [jobId]="jobId"
        (onUploadError)="onAdditionalCostUploadError($event)"
      ></vme-additional-costs>
    </div>
  </div>

  <job-screen-orders
    [organisationId]="organisationId"
    [organisationTypeId]="organisationTypeId"
    [jobId]="jobId"
  ></job-screen-orders>
</div>

<div *ngIf="activeViewId === 'routeItinerary' && job?.routeRecommendationId">
  <route-recommendation-detailed-view
    [routeRecommendationId]="job?.routeRecommendationId"
  ></route-recommendation-detailed-view>
</div>

<p-confirmDialog #cd2 header="Confirmation" icon="fa fa-icon-circle">
  <p-footer>
    <button
      class="ui-button-tertiary ui-button"
      type="button"
      pButton
      label="Cancel"
      (click)="cd2.reject()"
    ></button>
    <button
      class="ui-button ui-button-primary"
      type="button"
      pButton
      label="Confirm"
      (click)="cd2.accept()"
    ></button>
  </p-footer>
</p-confirmDialog>

<allocate-job-dialog
  *ngIf="allocateSupplier?.id && jobAllocationInfo"
  [(visible)]="showAllocateJobDialog"
  [supplierId]="allocateSupplier.id"
  [job]="jobAllocationInfo"
  (jobAllocated)="onAllocateJobSaved()"
  (close)="showAllocateJobDialog = false"
  referrPage="vmeJobScreen"
></allocate-job-dialog>
